import { MonitoringScope } from 'mormaii-web-presentation/monitoring'
import type { ViewFactory } from 'wdc-cube-solid'

import { MonitoringView } from './v-monitoring'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(MonitoringScope, MonitoringView)
}

export { MonitoringView }
